import { __decorate } from "tslib";
import { Component, Input, ViewChild } from '@angular/core';
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { DomSanitizer } from "@angular/platform-browser";
import { SharedHttp } from "../../../services/http-client.service";
import { LanguageService } from "../../../services/language.service";
import { isArray } from "jquery";
let PersonalVerificationComponent = class PersonalVerificationComponent {
    constructor(httpClient, themeService, sanitizer, languageService) {
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.languageService = languageService;
        this.borderRadiusSmaller = '';
        this.waterColor = '';
        this.lang = '';
        this.verificationCities = [];
        this.changeVerifyCity = false;
        this.verificationMethod = {};
        this.showThirdParty = false;
        this.showCaravan = false;
        this.atms = [];
        this.atmCities = [];
        this.showAtms = [];
        this.lastOpenIndex = -1;
        this.zoom = 6.2;
        this.latitude = 44.4419211;
        this.longitude = 20.4830112;
        this.styles = {};
        this.verificationMethodLoaded = false;
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.waterColor = this.themeService.getStyleAttribute('map_water_color');
            for (let i = 0; i < this.styles.length; i++) {
                if (this.styles[i].featureType === 'water') {
                    this.styles[i].stylers[0].color = this.waterColor;
                }
            }
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
    }
    ngOnInit() {
        this.getCities();
        this.getVerificationCities();
        this.styles = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "saturation": "-21"
                    },
                    {
                        "gamma": "2.98"
                    },
                    {
                        "weight": "4.77"
                    },
                    {
                        "lightness": "20"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#2a4e6e"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
    }
    getUserVerificationMethod() {
        this.httpClient.get('verificationmethod/getuserverification?lang=' + this.lang + '&city_id=' + this.userCityId).subscribe((data) => {
            this.verificationMethod = data;
            if (!this.verificationMethod.Icon) {
                this.verificationMethod.Icon = 'assets/img/user.svg';
            }
            this.showThirdParty = this.verificationMethod.Code.toLowerCase() === 'thirdparties';
            this.showCaravan = this.verificationMethod.Code.toLowerCase() === 'caravan';
            if (this.showThirdParty) {
                this.setActiveCityOnMap(this.verificationMethod.City);
            }
            else {
                this.verificationMethodLoaded = true;
            }
        });
    }
    getCities() {
        this.httpClient.get('verificationplaces/getallcities').subscribe((result) => {
            this.atmCities = isArray(result) && result.length > 0 ? result : [];
            this.getUserVerificationMethod();
        }, error => {
            this.getUserVerificationMethod();
        });
    }
    getVerificationCities() {
        this.httpClient.get('verificationplaces/getverificationcities').subscribe((result) => {
            this.verificationCities = result;
        });
    }
    setNewVerificationCity(city) {
        this.verificationMethodLoaded = false;
        this.httpClient.get('verificationmethod/getcityverification?cityid=' + city.id + '&lang=' + this.lang).subscribe((data) => {
            this.verificationMethod = data;
            this.showThirdParty = this.verificationMethod.Code.toLowerCase() === 'thirdparties';
            this.showCaravan = this.verificationMethod.Code.toLowerCase() === 'caravan';
            if (this.showThirdParty) {
                this.setActiveCityOnMap(city.name);
            }
            else {
                this.verificationMethodLoaded = true;
            }
            this.changeVerifyCity = false;
        });
    }
    setActiveCityOnMap(city) {
        this.httpClient.get('verificationplaces/getallplaces').subscribe((result) => {
            this.atms = isArray(result) && result.length > 0 ? result : [];
            const cityObj = this.atmCities.filter(x => x.name === city);
            if (cityObj.length > 0) {
                this.showAtms = this.atms.filter(x => x["validation-city"][0] === cityObj[0].id);
            }
            else {
                this.showAtms = this.atms;
            }
            this.verificationMethodLoaded = true;
        });
    }
    clickedMarker(data, index, type) {
        if (type === 'atm') {
            data['isOpen'] = true;
            if (this.lastOpenIndex > -1) {
                this.atms[this.lastOpenIndex]['isOpen'] = false;
            }
            this.lastOpenIndex = index;
        }
    }
    changeVerificationCity() {
        this.changeVerifyCity = true;
    }
    convertStringToNumber(value) {
        return +value;
    }
};
PersonalVerificationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: LanguageService }
];
__decorate([
    ViewChild('AgmMap')
], PersonalVerificationComponent.prototype, "agmMap", void 0);
__decorate([
    Input()
], PersonalVerificationComponent.prototype, "userCityId", void 0);
PersonalVerificationComponent = __decorate([
    Component({
        selector: 'ecd-personal-verification',
        template: __importDefault(require("./personal-verification.component.html")).default,
    })
], PersonalVerificationComponent);
export { PersonalVerificationComponent };
